module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [_c('el-form', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "30px"
    },
    attrs: {
      "label-width": "170px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "提现负责人姓名：",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "auto-complete": "off",
      "maxlength": "15",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.withdrawerName),
      callback: function($$v) {
        _vm.withdrawerName = $$v
      },
      expression: "withdrawerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提现负责人手机：",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "auto-complete": "off",
      "maxlength": "11",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.withdrawerPhone),
      callback: function($$v) {
        _vm.withdrawerPhone = $$v
      },
      expression: "withdrawerPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款账户信息：",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-radio-group', {
    on: {
      "change": function($event) {
        return _vm.radioType()
      }
    },
    model: {
      value: (_vm.collection),
      callback: function($$v) {
        _vm.collection = $$v
      },
      expression: "collection"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("公司个体户")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("个人账户")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行支行所在地：",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "185px"
    },
    attrs: {
      "placeholder": "请选择省"
    },
    on: {
      "change": function($event) {
        return _vm.getCity()
      }
    },
    model: {
      value: (_vm.provinceId),
      callback: function($$v) {
        _vm.provinceId = $$v
      },
      expression: "provinceId"
    }
  }, _vm._l((_vm.tbdprovince), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "185px"
    },
    attrs: {
      "placeholder": "请选择市 "
    },
    on: {
      "change": function($event) {
        return _vm.getzone()
      }
    },
    model: {
      value: (_vm.cityId),
      callback: function($$v) {
        _vm.cityId = $$v
      },
      expression: "cityId"
    }
  }, _vm._l((_vm.tbdcity), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "185px"
    },
    attrs: {
      "placeholder": "请选择区"
    },
    model: {
      value: (_vm.zoneId),
      callback: function($$v) {
        _vm.zoneId = $$v
      },
      expression: "zoneId"
    }
  }, _vm._l((_vm.tbdzone), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行银行名称：",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "auto-complete": "off",
      "maxlength": "30",
      "placeholder": "请输入开户行银行名称"
    },
    model: {
      value: (_vm.BankName),
      callback: function($$v) {
        _vm.BankName = $$v
      },
      expression: "BankName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号名称：",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "auto-complete": "off",
      "maxlength": "30",
      "placeholder": "请输入账号名称"
    },
    model: {
      value: (_vm.AccountName),
      callback: function($$v) {
        _vm.AccountName = $$v
      },
      expression: "AccountName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.bankAccount,
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "auto-complete": "off",
      "maxlength": "30",
      "placeholder": "请输入公司银行账号"
    },
    model: {
      value: (_vm.BankNo),
      callback: function($$v) {
        _vm.BankNo = $$v
      },
      expression: "BankNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.distinguish,
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "auto-complete": "off",
      "maxlength": "30",
      "placeholder": "请输入纳税人识别号"
    },
    model: {
      value: (_vm.TaxpayerAccount),
      callback: function($$v) {
        _vm.TaxpayerAccount = $$v
      },
      expression: "TaxpayerAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.emit()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61e6a803!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeManagement/userextend.vue
// module id = 1704
// module chunks = 3